export default "__VITE_ASSET__CCvS29dQ__"